export default function ($api) {
    return {
        /**
         * Отправить форму обратной связи
         * @returns { Object }
         */
        sendFeedback({ name, email, phone, theme, msg }) {
            return $api.post("api/form/feedback/", {
                name,
                email,
                phone,
                theme,
                msg,
            });
        },
        /**
         * Подписка на рассылку
         * @returns { Object }
         */
        subscribeTo({ email }) {
            return $api.post("api/subscribe/add/", {
                email,
            });
        },
        /**
         * Отправка формы для оптовых клиентов
         * @param { Object } data
         * @returns { Object }
         */
        sendPartnership(data) {
            return $api.post("api/form/partnership", data);
        },
        /**
         * Отправка общей формы для новых партнеров
         * @param { Object } data
         * @returns { Object }
         */
        sendPartnershipCommon(data) {
            return $api.post("api/form/partnership-common", data);
        },
        /**
         * Подписка на рассылку
         * @returns { Object }
         */
        subscribeUserByAction({ email }) {
            return $api.post("api/subscribe/add-user-by-action/", {
                email,
            });
        },
    };
}
